module.exports = __webpack_public_path__ + "9c93d793d2e35dabfb5cd4ce0e69fe11.svg";